var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49967 1.35902C4.38422 1.35902 1.85865 3.88459 1.85865 7.00004C1.85865 10.1155 4.38422 12.6411 7.49967 12.6411C10.6151 12.6411 13.1407 10.1155 13.1407 7.00004C13.1407 3.88459 10.6151 1.35902 7.49967 1.35902ZM0.833008 7.00004C0.833008 3.31814 3.81778 0.333374 7.49967 0.333374C11.1816 0.333374 14.1663 3.31814 14.1663 7.00004C14.1663 10.6819 11.1816 13.6667 7.49967 13.6667C3.81778 13.6667 0.833008 10.6819 0.833008 7.00004ZM6.98685 4.265C6.98685 3.98178 7.21645 3.75218 7.49967 3.75218H7.50651C7.78974 3.75218 8.01933 3.98178 8.01933 4.265C8.01933 4.54822 7.78974 4.77782 7.50651 4.77782H7.49967C7.21645 4.77782 6.98685 4.54822 6.98685 4.265ZM6.30309 7.00004C6.30309 6.71682 6.53269 6.48722 6.81591 6.48722H7.49967C7.7829 6.48722 8.0125 6.71682 8.0125 7.00004V9.22226H8.18344C8.46666 9.22226 8.69626 9.45186 8.69626 9.73508C8.69626 10.0183 8.46666 10.2479 8.18344 10.2479H7.49967C7.21645 10.2479 6.98685 10.0183 6.98685 9.73508V7.51286H6.81591C6.53269 7.51286 6.30309 7.28326 6.30309 7.00004Z",
    fill: "#653A92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPurple);
export default __webpack_public_path__ + "static/media/info-purple.9f982bcb14331e37b23ad8ca23ef0de7.svg";
export { ForwardRef as ReactComponent };